<!--
 * @Descripttion: 登录页面组件（密码/OTP 双模式）
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
 * @LastEditors: congz
 * @LastEditTime: 2020-08-19 10:14:30
-->

<template>
  <div class="login">
    <div>
      <el-card class="box-card" shadow="hover">
        <router-link class="login-logo-link" to="/">
          <img class="login-logo" src="../assets/imgs/clogo.png" alt />
        </router-link>
        <div class="clearfix">
          <span>Login</span>
        </div>
        <!-- 登录方式切换 -->
        <div class="login-tabs">
          <a
            href="javascript:;"
            :class="{ active: loginMode === 'password' }"
            @click="switchMode('password')"
          >Password</a>
          <a
            href="javascript:;"
            :class="{ active: loginMode === 'otp' }"
            @click="switchMode('otp')"
          >OTP</a>
        </div>
        <!-- 密码登录 -->
        <div class="item" v-if="loginMode === 'password'">
          <el-form :model="form" status-icon :rules="rules" ref="form">
            <el-form-item prop="user_name">
              <el-input v-model="form.user_name" placeholder="Username"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="form.password" placeholder="Password"></el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="login('form')">Login</a>
          </div>
        </div>
        <!-- OTP 登录 -->
        <div class="item" v-if="loginMode === 'otp'">
          <el-form :model="otpForm" status-icon :rules="otpRules" ref="otpForm">
            <el-form-item prop="phone">
              <el-input v-model="otpForm.phone" placeholder="Phone Number"></el-input>
            </el-form-item>
            <el-form-item prop="captcha_value" class="otp-item">
              <span class="math-captcha" title="Click to refresh" @click="refreshCaptcha">{{ captchaExpression }} = ?</span>
              <el-input v-model="otpForm.captcha_value" placeholder="Answer" class="otp-input"></el-input>
            </el-form-item>
            <el-form-item prop="code" class="otp-item">
              <el-input v-model="otpForm.code" placeholder="Verification Code" class="otp-input"></el-input>
              <a
                href="javascript:;"
                class="btn-gradient desert otp-btn"
                :class="{ disabled: otpSending || otpCountdown > 0 }"
                @click="sendCode"
              >{{ otpText }}</a>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="loginByOtp('otpForm')">Login / Register</a>
          </div>
        </div>
        <el-link
          type="primary"
          href="/#/register"
          style="float:right;margin-bottom:10px;"
        >Don't have an account? Please register first ></el-link>
        <div class="line"></div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
export default {
  name: 'Login',
  data() {
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('enter one user name'))
      } else if (value.length < 5 || value.length > 15) {
        callback(new Error('The username length should be between 5 and 15'))
      }
      callback()
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('The password length should be between 8 and 16'))
      }
      callback()
    }
    var validatePhone = (rule, value, callback) => {
      const phoneRegex = /^\d{10}$/
      if (value === '') {
        callback(new Error('Please enter your phone number'))
      } else if (!phoneRegex.test(value.replace(/\D/g, ''))) {
        callback(new Error('Please enter a valid 10-digit phone number'))
      } else {
        callback()
      }
    }
    var validateOtp = (rule, value, callback) => {
      const otpRegex = /^\d{6}$/
      if (value === '') {
        callback(new Error('Please enter the verification code'))
      } else if (!otpRegex.test(value)) {
        callback(new Error('Verification code must be 6 digits'))
      } else {
        callback()
      }
    }
    var validateCaptcha = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the math captcha answer'))
      } else {
        callback()
      }
    }
    return {
      loginMode: 'password',
      form: {
        user_name: '',
        password: '',
        challenge: '',
        validate: '',
        seccode: ''
      },
      otpForm: {
        phone: '',
        captcha_value: '',
        code: ''
      },
      rules: {
        user_name: [{ validator: validateUser, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }]
      },
      otpRules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        captcha_value: [{ validator: validateCaptcha, trigger: 'blur' }],
        code: [{ validator: validateOtp, trigger: 'blur' }]
      },
      captchaID: 0,
      captchaExpression: '',
      otpSending: false,
      otpCountdown: 0,
      otpTimer: null
    }
  },
  computed: {
    otpText() {
      if (this.otpCountdown > 0) {
        return `${this.otpCountdown}s`
      }
      return this.otpSending ? 'Sending...' : 'Send Code'
    }
  },
  methods: {
    ...mapActions(['setUser']),
    switchMode(mode) {
      this.loginMode = mode
    },
    refreshCaptcha() {
      var self = this
      userAPI.getMathCaptcha().then(res => {
        if (res.status === 200 && res.data) {
          self.captchaID = res.data.captcha_id
          self.captchaExpression = res.data.expression
        }
      })
      this.otpForm.captcha_value = ''
    },
    startOtpCountdown() {
      this.otpCountdown = 60
      this.otpTimer = setInterval(() => {
        if (this.otpCountdown > 0) {
          this.otpCountdown--
        } else {
          clearInterval(this.otpTimer)
          this.otpSending = false
        }
      }, 1000)
    },
    sendCode() {
      var self = this
      this.$refs.otpForm.validateField('phone', errorMessage => {
        if (errorMessage) {
          return
        }
        if (self.otpSending || self.otpCountdown > 0) {
          return
        }
        this.$refs.otpForm.validateField('captcha_value', errorMessage => {
          if (errorMessage) {
            return
          }
          self.otpSending = true
          var phone = self.otpForm.phone.replace(/\D/g, '')
          userAPI
            .sendOtp({ phone: phone, purpose: 'login', captcha_id: self.captchaID, captcha_value: self.otpForm.captcha_value })
            .then(res => {
              if (res.status === 200) {
                self.notifySucceed('Verification code sent')
                self.startOtpCountdown()
                // 数学验证码一次性：发送成功后刷新
                self.refreshCaptcha()
              } else {
                self.otpSending = false
                // 数学验证码错误时也刷新，避免旧验证码重复试错
                if (res.status === 20016) {
                  self.refreshCaptcha()
                }
                self.notifyError('Failed to send code', res.msg)
              }
            })
            .catch(error => {
              self.otpSending = false
              self.notifyError('Failed to send code', error)
            })
        })
      })
    },
    loginByOtp(formName) {
      var self = this
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        var submitForm = {
          phone: self.otpForm.phone.replace(/\D/g, ''),
          code: self.otpForm.code
        }
        userAPI
          .smsLogin(submitForm)
          .then(res => {
            if (res.status === 200) {
              // 登录信息存到本地
              let user = JSON.stringify(res.data.user)
              localStorage.setItem('user', user)
              localStorage.setItem('token', res.data.token)
              // 登录信息存到vuex
              self.setUser(res.data.user)
              // 弹出通知框提示登录成功信息
              self.notifySucceed('Login successful')
              self.$router.push({
                name: 'Home'
              })
            } else {
              self.notifyError('Login failed', res.msg)
            }
          })
          .catch(error => {
            self.notifyError('Login failed', error)
          })
      })
    },
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        userAPI
          .postLogin(this.form)
          .then(res => {
            if (res.status === 404) {
              this.notifyError('Verification failed', res.msg)
            } else if (res.status === 200) {
              // 登录信息存到本地
              let user = JSON.stringify(res.data.user)
              localStorage.setItem('user', user)
              localStorage.setItem('token', res.data.token)
              // 登录信息存到vuex
              this.setUser(res.data.user)
              // 弹出通知框提示登录成功信息
              this.notifySucceed('Login successful')
              this.$router.push({
                name: 'Home'
              })
            } else {
              this.notifyError('Login failed', res.msg)
            }
          })
          .catch(error => {
            this.notifyError('Login failed', error)
          })
      })
    }
  },
  beforeDestroy() {
    if (this.otpTimer) {
      clearInterval(this.otpTimer)
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
  margin-bottom: 20px;
}

.login-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.login-tabs a {
  display: inline-block;
  width: 100px;
  line-height: 34px;
  text-align: center;
  color: #757575;
  border-bottom: 2px solid transparent;
  font-size: 14px;
}

.login-tabs a.active {
  color: #f56c6c;
  border-bottom: 2px solid #f56c6c;
}

.otp-item ::v-deep .el-form-item__content {
  display: flex;
}

.math-captcha {
  width: 90px;
  line-height: 38px;
  margin-right: 10px;
  text-align: center;
  background: #f0f0f0;
  border-radius: 4px;
  font-size: 15px;
  font-weight: bold;
  color: #444;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
}

.otp-input {
  flex: 1;
  margin-right: 10px;
}

.otp-btn {
  width: 110px;
  padding: 0;
  line-height: 38px;
  text-align: center;
  font-size: 13px;
}

.otp-btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 300px;
  border-radius: 10px;
}
.login-logo-link {
  display: flex;
  justify-content: center;
}
.login-logo {
  width: 120px;
  height: auto;
}
.box-card .line {
  height: 30px;
  width: 300px;
  margin: 0 auto;
  border-bottom: 1px solid #c0c0c0;
}
</style>
